import { Tooltip, Toast, Popover } from 'bootstrap';
import Vue from 'vue';
import { store } from './store/';
import App from "../components/core/App.vue";
import VueRouter from 'vue-router';
import { routerConfig } from "./router/config"
import api from "./api.js"
import Quasar from 'quasar'

Vue.use(VueRouter)
export const router = new VueRouter(routerConfig);

Vue.config.productionTip = false

// provide API access across all application components
// inside components: this.$api.get(endpoint, payload); this.$api.post(endpoint, payload);
// inside store action: this._vm.$api.get(endpoint, payload); this._vm.$api.post(endpoint, payload);
// anywhere else in app: Vue.api.get(payload); Vue.api.post(payload);

Vue.use(Quasar)

Vue.use({
  install () {
    Vue.api = api
    Vue.prototype.$api = api
  }
})

new Vue({
    router,
    store,
    beforeCreate() {
		this.$store.commit('ProductCollection/initialiseStore');
	},
    render: h => h(App)
}).$mount('#app')
